import React from 'react'
import PropTypes from 'prop-types'

const t = (key) => (!window.I18n ? key : window.I18n.t(key))

const formatHI = (usgaIndex) => usgaIndex || '-'

const ImportMasterRosterRow = ({ member, isAdding, isFailed, onAdd }) => (
  <div className='import-panel__row'>
    <div className='import-panel__member-info'>
      <span className='import-panel__member-name'>
        {member.handle}
      </span>
      {(member.usga_index != null || member.email) && (
        <span className='import-panel__member-meta'>
          {member.usga_index != null && `${t('customer_groups.groups.members.columns.handicap_index')}: ${formatHI(member.usga_index)}`}
          {member.usga_index != null && member.email && ' | '}
          {member.email}
        </span>
      )}
    </div>
    <button
      className='btn btn-sm btn-default import-panel__add-btn'
      onClick={() => onAdd(member.id)}
      disabled={isAdding || isFailed}
    >
      {isAdding
        ? <i className='fa fa-spinner fa-spin' />
        : t('customer_groups.groups.members.import_panel.add_button')}
    </button>
  </div>
)

ImportMasterRosterRow.propTypes = {
  member: PropTypes.shape({
    id: PropTypes.string.isRequired,
    handle: PropTypes.string,
    usga_index: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  isAdding: PropTypes.bool.isRequired,
  isFailed: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
}

export default ImportMasterRosterRow
